import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from 'context/Context';
import propTypes from 'prop-types';

export default function PublicRoute({ children, redirect }) {
  const { auth, loading } = useContext(AuthContext);
  const shouldRedirect = auth && !loading;

  return shouldRedirect ? <Navigate to={redirect} /> : children;
}

PublicRoute.propTypes = {
  children: propTypes.element.isRequired,
  redirect: propTypes.string.isRequired
};
